import React, { createContext, useState, useEffect } from 'react';
import { useFeatureFlag } from '@moda/portal-stanchions';
import { CONFIG } from '../../config';

export const ApplePayContext = createContext({ isApplePaySupported: false });

const checkApplePaySupport = () =>
  typeof ApplePaySession !== 'undefined'
    ? ApplePaySession.canMakePaymentsWithActiveCard(CONFIG.APPLE_MERCHANT_IDENTIFIER)
    : Promise.resolve(false);

export const ApplePayProvider: React.FC = ({ children }) => {
  const [isApplePaySupported, setIsApplePaySupported] = useState(false);

  const isApplePayEnabled = useFeatureFlag('show-apple-pay', [
    { default: false },
    { if: true, then: true }
  ]);

  useEffect(() => {
    checkApplePaySupport().then(setIsApplePaySupported);
  }, []);

  return (
    <ApplePayContext.Provider
      value={{ isApplePaySupported: isApplePaySupported && isApplePayEnabled }}
    >
      {children}
    </ApplePayContext.Provider>
  );
};
